var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"btn-primary btn file-uploader"},[_vm._v("\n        Upload File\n        "),_c('input',{attrs:{"type":"file","name":"file","id":"file"},on:{"change":_vm.uploadFile}})])])}
var staticRenderFns = []

export { render, staticRenderFns }